import PackingList from '../views/packing_lists/Index.vue'
import PackingListPrint from '../views/packing_lists/Print.vue'
import {checkauth} from "../Helper";

const PackingListCreate = () => import('../views/packing_lists/Create.vue')
const PackingListEdit = () => import('../views/packing_lists/Edit.vue')

function auth(to, from, next) {
    checkauth().then(response => {
        if (response) {
            next();
        } else {
            next('/login');
        }
    })
}

export default [
    {
        path: '/packing-list',
        name: 'packing_list',
        component: PackingList,
        beforeEnter: auth,
    },
    // avvio (badge operatore + ordine) e dettaglio: pagine, non piu' finestre della lista
    {
        path: '/packing-list/new',
        name: 'packing_list_new',
        component: PackingListCreate,
        beforeEnter: auth,
    },
    {
        path: '/packing-list/:id([0-9a-fA-F]{24})',
        name: 'packing_list_edit',
        component: PackingListEdit,
        beforeEnter: auth,
    },
    {
        path: `/packing-list/print/:id`,
        name: `packing_listPrint`,
        component: PackingListPrint,
        beforeEnter: auth,
    },
]
